// Peter Mergenthaler Jr / Integritos Real Estate site configuration.
// Keep agent-specific identity, contact, brand, market, and MLS values here.
export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 'peter.m.palmbeach',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'integritosrealestate.com',
  INSIGHTS_MARKET_NAME: 'Palm Beach County',
  AGENT_YEARS: '34',
  ANALYTICS: { GA4_MEASUREMENT_ID: 'G-QTH5ZG4ZEW' },
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=e98a5c09-138b-4dd4-9b74-2c40e450a053&token=SE6G2CEa51sRmXkEPcQlFlUfeZA8lYmdHO99ZKVQ&operation=startbuild',
  SENDER_EMAIL_ENCRYPTION_KEY: '',
  STATE: 'FL',
  SEARCH_STATES: ['FL'],
  SERVICE_COUNTIES: ['Miami-Dade County', 'Broward County', 'Palm Beach County', 'Martin County', 'St. Lucie County'],
  BRAND: { PRIMARY: '#17191c', SECONDARY: '#3d4044', ACCENT: '#c91822' },
  AGENT: {
    MLS_ID: '20013406',
    OFFICE_KEYS: [5924587],
    NAME: 'Peter Mergenthaler Jr',
    BROKERAGE: 'Integritos Real Estate',
    TITLE: 'Real Estate Broker, REALTOR®, GRI',
    ASSISTANT_NAME: 'Peter Mergenthaler Jr.’s AI Assistant',
    EMAIL: 'help@integritosrealestate.com',
    // Dedicated website line so inbound calls and texts can be attributed to the site.
    PHONE: '+1-561-220-6438',
    PHONE_DISPLAY: '(561) 220-6438',
    DIRECT_PHONE: '+1-561-723-5955',
    OFFICE_PHONE: '+1-561-823-4294',
    ZILLOW_PROFILE: 'https://www.zillow.com/profile/integritos',
    ZILLOW_REVIEW: 'https://www.zillow.com/reviews/write/?s=X1-ZU187nx9oz016vd_3qul1',
    GOOGLE_REVIEW: 'https://www.google.com/search?hl=en-US&kgmid=%2Fg%2F11yhh_2sjd&q=Peter+Mergenthaler+Jr+-+Integritos+Real+Estate',
    BROKERAGE_LICENSE: 'BK3608530',
    LICENSE: 'BK3608530'
  },
  OFFICES: [{
    name: 'Delray Beach Office', hq: true,
    street: '504 East Atlantic Avenue, Suite 200', city: 'Delray Beach', state: 'FL', zip: '33483',
    phone: '(561) 823-4294', email: 'help@integritosrealestate.com', lat: 26.4615, lon: -80.0673
  }],
  LANDING_PAGE: {
    ICONS: {
      MOON: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-moon.png',
      SUN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-sun.png',
      BLOGS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-blogs.png',
      REVIEWS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-reviews.png',
      SEARCH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-globe.png',
      AGENT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-agent.png',
      ACCOUNT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-account.png',
      ADMIN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-admin.png'
    },
    VIDEOS: {
      DESKTOP: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/fl--pete-main-002.mp4',
      TABLET: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/fl--pete-main-002.mp4',
      MOBILE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/fl--pete-main-002.mp4',
      SHOWCASE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/Drone_flying_over_tropical_resort_202608261223.mp4',
      HOME_VALUE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/fl-scenery-001.mp4'
    },
    EDITORIAL_IMAGES: {
      LIVING_ROOM: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-living-room-002.jpg',
      CONDO_INTERIOR: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-003.jpeg'
    },
    AGENT_IMAGE: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/peter-hs-002.jpeg',
    AGENT_EDITORIAL_IMAGE: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/peter-hs-001.jpeg',
    AGENT_LOGO: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/pete.m.white.logo.png',
    BROKERAGE_LOGO: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/pete.m.white.logo.png',
    REVIEW_SUMMARY: { RATING: '5.0', COUNT: 2, SOURCE: 'Zillow' },
    FEATURED_REVIEWS: [
      { id: 'zillow-vernon-rebello-2025', review_text: 'Peter oversaw the preparation, lease, and association approval with professionalism from beginning to end.', author: 'Vernon Rebello', detail: 'Bought & sold · 2025', rating: 5, source: 'Zillow', source_url: 'https://www.zillow.com/profile/integritos#reviews' },
      { id: 'zillow-doctorperdei-2014', review_text: 'Professional, knowledgeable, and genuinely focused on his client’s interests, Peter consistently went the extra mile.', author: 'doctorperdei', detail: 'Buyer · Palm Beach County', rating: 5, source: 'Zillow', source_url: 'https://www.zillow.com/profile/integritos#reviews' },
      { id: 'realtor-lenka-tichy', review_text: 'Peter combined strong market knowledge with a personal, patient approach. His responsiveness, honesty, and attention to detail inspired confidence throughout the process.', author: 'Lenka Tichy', detail: 'Client · South Florida', source: 'Realtor.com', source_url: 'https://www.realtor.com/realestateagents/Peter-Mergenthaler-Jr_West-Palm-Beach_FL_100717840_302094327' },
      { id: 'realtor-jafet-pretel', review_text: 'Peter kept my best interests at heart, stayed available, offered sound advice, and made the entire process feel far less stressful.', author: 'Jafet Pretel', detail: 'Client · South Florida', source: 'Realtor.com', source_url: 'https://www.realtor.com/realestateagents/Peter-Mergenthaler-Jr_West-Palm-Beach_FL_100717840_302094327' },
      { id: 'realtor-dr-bone', review_text: 'After working with Peter for a decade, this client highlighted his local knowledge, negotiation expertise, and ability to solve difficult transaction problems.', author: 'Dr. Bone', detail: 'Long-term client', source: 'Realtor.com', source_url: 'https://www.realtor.com/realestateagents/Peter-Mergenthaler-Jr_West-Palm-Beach_FL_100717840_302094327' },
      { id: 'realtor-rizzieri-gomes', review_text: 'Peter guided every detail with patience and expertise while protecting the client from poor decisions and keeping long-term value and family goals in focus.', author: 'Rizzieri Gomes', detail: 'Buyer · South Florida', source: 'Realtor.com', source_url: 'https://www.realtor.com/realestateagents/Peter-Mergenthaler-Jr_West-Palm-Beach_FL_100717840_302094327' }
    ],
    CITY_IMAGES: {
      DELRAY_BEACH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-003.jpeg',
      BOCA_RATON: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-005.jpeg',
      BOYNTON_BEACH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-6.jpeg',
      HIGHLAND_BEACH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-001.jpeg',
      WEST_PALM_BEACH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-004.jpeg',
      PALM_BEACH_GARDENS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-002.jpeg',
      JUPITER: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-007.jpeg',
      WELLINGTON: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_outsidehome_ga_002.jpg',
      LAKE_WORTH_BEACH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-living-room-002.jpg',
      FORT_LAUDERDALE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-004.jpeg',
      MIAMI: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-005.jpeg',
      STUART: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-001.jpeg',
      PORT_ST_LUCIE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-fl-007.jpeg'
    },
    FOOTER_LOGO: 'https://aw-business-marketing.s3.us-east-1.amazonaws.com/websitesbyaw-transparent.png'
  },
  MLS: {
    NAME: 'BeachesMLS', SHORT_NAME: 'BeachesMLS',
    LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/beaches.logo.png',
    DISCLAIMER: `Copyright ©${new Date().getFullYear()} BeachesMLS, Inc. All listings featuring the BMLS logo are provided by BeachesMLS, Inc. This information is not verified for authenticity or accuracy and is not guaranteed.`
  }
};

export const mlsForState = () => SITE_CONFIG.MLS;

export const SEO_CONFIG = {
  AGENT_NAME: SITE_CONFIG.AGENT.NAME,
  AGENT_EMAIL: SITE_CONFIG.AGENT.EMAIL,
  AGENT_PHONE: SITE_CONFIG.AGENT.PHONE,
  STREET_ADDRESS: '504 East Atlantic Avenue, Suite 200',
  CITY: 'Delray Beach', STATE: SITE_CONFIG.STATE, ZIP_CODE: '33483', COUNTRY: 'US',
  LATITUDE: '26.4615', LONGITUDE: '-80.0673',
  DOMAIN: `https://${SITE_CONFIG.BASE_URL.replace(/^https?:\/\//, '').replace(/^www\./, '')}`,
  FACEBOOK_URL: 'https://www.facebook.com/integritos/',
  INSTAGRAM_URL: 'https://www.instagram.com/integritos/',
  LINKEDIN_URL: 'https://www.linkedin.com/in/petermergenthalerjr/',
  TWITTER_HANDLE: '',
  OG_IMAGE: SITE_CONFIG.LANDING_PAGE.AGENT_EDITORIAL_IMAGE,
  TWITTER_IMAGE: SITE_CONFIG.LANDING_PAGE.AGENT_EDITORIAL_IMAGE,
  LOGO_URL: SITE_CONFIG.LANDING_PAGE.AGENT_LOGO
};
